module.exports = __webpack_public_path__ + "img/icon-yandex-business.03387805.svg";